"use client";

import { ConvexError } from "convex/values";
import { Component, type ReactNode } from "react";
export class AssistantProposalBoundary extends Component<{
  children: ReactNode;
}, {
  failed: boolean;
  message: string;
}> {
  state = {
    failed: false,
    message: "Não foi possível acessar esta revisão. Peça uma nova proposta."
  };
  static getDerivedStateFromError(cause: unknown) {
    return {
      failed: true,
      message: cause instanceof ConvexError && typeof cause.data === "string" ? cause.data : "Não foi possível acessar esta revisão. Peça uma nova proposta."
    };
  }
  render() {
    return this.state.failed ? <p role="status">{this.state.message}</p> : this.props.children;
  }
}